var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 169,
    viewBox: "0 0 117 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(-1075 -1687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_indicator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    transform: "translate(1173 1687)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1178 1692)",
    fill: "#f6d515"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 102,
    transform: "translate(1080.5 1696.5)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 3,
    y2: 157,
    transform: "translate(1078 1695.5)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    transform: "translate(1075 1850)",
    fill: "#f6d515",
    stroke: "#f6d515",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPair);
export default __webpack_public_path__ + "static/media/pair.c9d7e49ad45e2ca65b177ab6cd85e162.svg";
export { ForwardRef as ReactComponent };